<template>
  <div class="card card-travel-preview card-vacation-destination">
    <div class="price" v-if="travelInfo.priceFrom">ab&nbsp;<price :given="travelInfo.priceFrom" /></div>
    <a :href="$route('travel-destination', travelInfo)">
    <img
      :src="travelInfo.teaserMediumUrls[0]"
      class="card-img-top"
      alt="Urlaubsziel"
    />
    </a>
    <div class="card-body">
      <h5 class="card-title mt-4 mb-3">{{ travelInfo.destination }}</h5>
      <div class="card-text" v-html="travelInfo.description"></div>
    </div>
    <div class="card-footer">
      <a
        :href="$route('travel-destination', travelInfo)"
        class="btn btn-outline-primary rounded-pill mb-4"
      >
        <i class="fas fa-skiing me-2"></i> Details
      </a>
    </div>
  </div>
</template>

<script>
import { Link, useForm, usePage } from "@inertiajs/inertia-vue3";
import Price from "./Price";

export default {
  components: {
    Price,
  },
  props: {
    model: Object,
  },
  data() {
    return {
      travelInfo: this.model,
    };
  },
//   methods: {
//     priceFrom() {
//       axios
//         .post(
//           route("ratio.travel-date-price", {
//             travelDate: travelDate.value.get("slug"),
//           }),
//           search.value.data
//         )
//         .then(function (response) {
//           state.price = response.data.price;
//         })
//         .catch(function (error) {
//           console.log(error);
//         });
//     },
//   },
//   mounted() {
//     this.priceFrom()
//   },
};
</script>
